// extracted by mini-css-extract-plugin
export var grayCircle = "_fb-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_fb-1";
export var selectedCircle = "_fb-2";
export var shippingOptionImage = "_fb-3";
export var shippingOptionWidgetPreview = "_fb-4";